import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DocumentServiceGateway } from 'src/app/application/gateway/DocumentServiceGateway';
import { ExportOfferDocumentGateway } from 'src/app/application/gateway/ExportOfferDocumentGateway';
import { ExportOfferDocument } from 'src/app/domain/models/ExportOfferDocument';
import { ImportOrderDocument } from 'src/app/domain/models/ImportOrder';

@Component({
  selector: 'app-upload-export-documents',
  templateUrl: './upload-export-documents.component.html',
  styleUrls: ['./upload-export-documents.component.css']
})
export class UploadExportDocumentsComponent implements OnInit {

    @Input()
    exportOfferId: number | undefined

    @Input()
    orderId: string | undefined

    @Input()
    mode: "order" | "exportOffer" = "exportOffer";

    @Output() OnCancelEvent = new EventEmitter<void>();
    @Output() OnSaveEvent = new EventEmitter<void>();

    exportOfferDocuments: ExportOfferDocument[] = []
    selectedRows: ExportOfferDocument[] = []
    loading: boolean = false;

    constructor(private _router: Router,
      private _messageService: MessageService,
      private _documentService: DocumentServiceGateway,
      private _exportOfferDocumentService: ExportOfferDocumentGateway,
      public translate: TranslateService) {

    }

    ngOnInit(): void {
      this.getAllExportDocuments();
    }

    getAllExportDocuments() {
        this.loading = true
        this._exportOfferDocumentService.getAllFreeByProfile().subscribe({
          next: (v) => {
            this.exportOfferDocuments = v
            this.loading = false
          },
          error: (e) => {
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: this.translate.instant('MessageService.ProductCertificate.ManyRetrieveError') });
            console.log(e)
            this.loading = false
          },
          complete: () =>  {
            this.loading = false
            console.info('Product Certificates query successfully')
          }
      })
    }

    copyExportOfferDocument()
    {
      if(this.exportOfferId && this.selectedRows.length > 0)
      {
        this.loading = true;
        let ids = this.selectedRows.map(x => x.id);
        this._exportOfferDocumentService.copyExportDocumentToExportOffer(this.exportOfferId, ids).subscribe(
          {
            next: (v) => {
              this.loading = false;
              this.OnSaveEvent.emit();

            },
            error: (e) => {
              this.loading = false;
            }
          }
        )
      }
    }

  getExportOfferDocument(exportOfferDocumentId: number) {
    this._documentService.getExportOfferDocument2(exportOfferDocumentId).subscribe((resultBlob: any) => {
      var downloadURL = window.URL.createObjectURL(resultBlob.body);
      window.open(downloadURL);})
    }

  cancel()
  {
    this.OnCancelEvent.emit();
  }

  saveExportOfferDocumentEvent()
  {
    if(this.mode == "exportOffer")
    {
      this.copyExportOfferDocument()
    }else{
      this.assignCertificateToOrder()
    }
  }

  assignCertificateToOrder()
  {
    if(this.orderId && this.selectedRows.length > 0)
    {
      this.loading = true;
      let ids = this.selectedRows.map(x => x.id);

            this._exportOfferDocumentService.assignExportOfferDocument
            (
              this.orderId,
              ids
            )
          .subscribe(
        {
          next: (v) => {
            this.loading = false;
            this._messageService.add({ severity: 'info',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.ExportOfferDocument.AssignSuccess')})
            this.OnSaveEvent.emit();

          },
          error: (e) => {
            this.loading = false;
            this._messageService.add({ severity: 'info',
              summary: this.translate.instant('MessageService.Summary.SuccessAction'),
              detail: this.translate.instant('MessageService.ExportOfferDocument.AssignError')})
          }
        }
      )
    }
  }
}
